import classNames from 'classnames';
import React, { FC } from 'react';
import { Image } from '../Image';
import styles from './PGUseCard.module.scss';
import type { ImgCompressOptions } from '../../util/imgLoader';

interface Props {
  cardDirClass?: string;
  cardImgClass?: string;
  compressOptions?: ImgCompressOptions;
  pgUseCardData: { [key: string]: string };
}

const PGUseCard: FC<Props> = (props) => {
  const { pgUseCardData, cardDirClass, cardImgClass, compressOptions = { quality: 60 } } = props;
  const defaultdir = 'flex-col';
  const dafaultCardImgCalss = 'h-18.375r lg:h-34.5r w-full lg:w-full';
  const contentClassName = cardDirClass === 'flex-row' ? 'flex-col' : 'flex-row';
  const dirClassName = cardDirClass || defaultdir;
  const cardImgClassName = cardImgClass || dafaultCardImgCalss;
  return (
    <div className={classNames(styles['pg-use-card-box'], dirClassName)}>
      <div className={styles['card-content-box']}>
        <div className={styles['use-card-title']}>{pgUseCardData.title}</div>
        <div className={classNames(styles['use-card-intro-box'], contentClassName)}>
          <p className={styles['use-card-intro']}>{pgUseCardData.intro1}</p>
          <p className={styles['use-card-intro']}>{pgUseCardData.intro2}</p>
        </div>
      </div>
      <div className={classNames(styles['card-img-box'], cardImgClassName, 'relative')}>
        <Image src={pgUseCardData.img} objectFit="cover" layout="fill" compressOptions={compressOptions} />
      </div>
    </div>
  );
};

PGUseCard.displayName = 'PGUseCard';

export default PGUseCard;
